import type { Organization } from "./api";
import { type Page, route } from "./route";

/** The organizations to offer in the switcher: none when the user has a role in only one (rule U-9). */
export function switchable(found: readonly Organization[]): Organization[] {
  return found.length > 1 ? [...found] : [];
}

export const orgHref = (slug: string): string => `/o/${encodeURIComponent(slug)}`;

const LIST_OF: Partial<Record<Page, Page>> = { tank: "tanks", account: "accounts", lead: "leads", deal: "deals", agreement: "deals", rebate: "rebates", user: "users", role: "roles", unit: "inventory" };

/** The same page in the other organization; a record page opens its list, and a settings page keeps its section (rule U-9). */
export function switchHref(slug: string, path: string, hash = ""): string {
  const now = route(path);
  if (now.kind !== "org" || now.page === "home" || now.page === "missing") return orgHref(slug);
  const section = (now.page === "settings" || now.page === "admin") && /^#[\w-]+$/.test(hash) ? hash : "";
  return `${orgHref(slug)}/${LIST_OF[now.page] ?? now.page}${section}`;
}
